import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const NotFoundPage: React.FC = () => {
    const handleRedirect = () => {
        window.location.href = "/"; // Redirects to the homepage
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="text-center">
                <h1 className="display-1 fw-bold text-danger">404</h1>
                <p className="fs-3">
                    <span className="text-danger">Oops!</span> Page not found.
                </p>
                <p className="lead">The page you’re looking for doesn’t exist.</p>
                <button onClick={handleRedirect} className="btn btn-primary">
                    Go Home
                </button>
            </div>
        </div>
    );
};

export default NotFoundPage;
